import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllEmployees = createAsyncThunk('employees/getAllEmployees', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/employees?limit=10&page=${page}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
